import { Box, Text, useMantineTheme } from '@mantine/core'
import { useMemo } from 'react'
import useCountdown from '@/hooks/useCountDown'
import { usePersistentDate } from '@/hooks/usePersistentDate'
import AlertContainer from './AlertContainer'
import { Trans } from 'react-i18next'
import { CAR_SERVER_UNREACHABLE_ALERT_MINUTES, HOTLINE_NUMBER } from '@/constants'

export const CarServerUnreachableAlert = () => {
  const theme = useMantineTheme()
  const targetDate = usePersistentDate(CAR_SERVER_UNREACHABLE_ALERT_MINUTES)
  const countdown = useCountdown(targetDate)

  const alertText = useMemo(() => {
    return (
      <>
        <Trans ns="errors" i18nKey="carServerIsUnreachableBody">
          <Text fw={700} fz="var(--spacing-lg)">
            Please drive to a safe position and wait a minimum of 10 minutes before continuing.
          </Text>
        </Trans>
        {countdown?.minutes > 0 || (countdown?.minutes === 0 && countdown?.seconds !== 0) ? (
          <Box mt="lg">
            {countdown?.minutes}m {countdown?.seconds}s
          </Box>
        ) : (
          <Box
            mt="lg"
            style={{
              display: 'flex',
              gap: `calc(${theme.spacing.xs} / 2)`,
              flexDirection: 'column',
            }}
            fz="var(--spacing-lg)"
          >
            <Trans ns="errors" i18nKey="emergencyLine">
              In case of persistent issues with the car please call{' '}
              <strong>{{ emergencyLine: HOTLINE_NUMBER } as unknown as React.ReactNode}</strong>
            </Trans>
          </Box>
        )}
      </>
    )
  }, [countdown, theme.spacing.xs])

  return <AlertContainer type="alert" alertText={alertText} alertColor="orange" height="small" />
}
